// src/components/AdminLayout.tsx

import { Outlet, useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';

export function AdminLayout() {
  const navigate = useNavigate();
  const logout = useAppStore((s) => s.logout);

  return (
    <div className="app-layout">
      <header className="app-header">
        <span className="app-title">⚙️ Admin Panel</span>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <button
            className="logout-button"
            onClick={() => navigate('/years')}
            style={{ minHeight: '44px' }}
          >
            ← Back to Albums
          </button>
          <button
            className="logout-button"
            onClick={() => { logout(); navigate('/login'); }}
            style={{ minHeight: '44px' }}
          >
            Logout
          </button>
        </div>
      </header>
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}
